import React from 'react';

function Results() {
  return (
    <section className="section section--light results" id="results">
      <div className="mission">
        <div className="mission-aside">
          <span className="section-label">Our Mission</span>
          <h2>
            Practical solutions.
            <br />
            Real experience.
          </h2>
          <blockquote className="quote">
            <p>
              “Businesses deserve automation and technology solutions that
              actually fit their needs.”
            </p>
            <footer>
              <span className="avatar" aria-hidden="true">GI</span>
              <span>
                <strong>GEN IT SOLUTIONS INC</strong>
                AI, applications, and consulting
              </span>
            </footer>
          </blockquote>
        </div>

        <div className="mission-body">
          <p>
            Genitsolutions INC was founded on a simple belief: businesses
            deserve automation and technology solutions that actually fit
            their needs — not whatever is easiest to sell.
          </p>
          <p>
            Too often, companies are offered generic IT support that treats
            symptoms instead of solving root problems. We take a different
            approach. We assess your current processes, identify where
            automation can eliminate manual work, and build intelligent
            workflows that save your team hours every week.
          </p>
          <p>
            Our team brings decades of combined experience across software
            development, database administration, system architecture, and
            AI-driven automation. We&apos;ve built and maintained systems for
            real businesses — we don&apos;t recommend what we haven&apos;t used
            ourselves.
          </p>
          <p>
            We&apos;re a small company by choice. That means you work directly
            with the people building your solutions — no handoffs, no layers,
            no runaround. Every project gets senior-level attention from start
            to finish.
          </p>
          <p>
            We won&apos;t sell you tools you don&apos;t need or pretend to be
            something we aren&apos;t. If there&apos;s a better path, we&apos;ll
            tell you. If something isn&apos;t working, we&apos;ll say so.
            That&apos;s the kind of partner we are.
          </p>
          <p>
            Thank you for visiting our website. Please feel free to contact us
            with any questions.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Results;